import { Card, Flex, PageHeader, Separator, Skeleton } from '@driftt/dds'
import React from 'react'

import PlaybookPageLayout from 'components/PlaybookPage'
import { APP_PAGE_TITLES } from 'constants/pageTitles'

export const GuardrailsEditorLoader = () => {
  return (
    <PlaybookPageLayout pageTitle={APP_PAGE_TITLES.GUARDRAIL}>
      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.Title>
            <Skeleton
              isLoading
              width="200px"
              height="20px"
              css={{ marginTop: 2 }}
            />
          </PageHeader.Title>
          <PageHeader.Secondary>
            <Skeleton isLoading width="100px" height="20px" />
          </PageHeader.Secondary>
        </PageHeader.Main>
        <Separator />
        <Flex
          css={{
            padding: '$3',
            backgroundColor: '$gray2',
            overflow: 'auto',
            paddingBottom: 150,
            zIndex: 0,
            '> div': {
              width: '1040px',
              maxWidth: '100%',
            },
          }}
          direction="column"
          fullHeight
          fullWidth
          gap={2}
          alignItems="center"
        >
          {Array.from({ length: 3 }).map(() => (
            <Card width="100%">
              <Card.Header>
                <Skeleton isLoading width="100%" height="20px" />
                <Skeleton
                  isLoading
                  width="100%"
                  height="16px"
                  css={{ marginTop: 2 }}
                />
              </Card.Header>
              <Card.Content>
                <Skeleton isLoading width="100%" />
              </Card.Content>
            </Card>
          ))}
        </Flex>
      </PageHeader.Root>
    </PlaybookPageLayout>
  )
}
